

/* tslint:disable */



export enum ActivityRequestResourceType {
    MedicationRequest = 9,
    ServiceRequest = 11,
    MedicationGroup = 15,

}


